import styled from "styled-components";
import { CenterFlexRow } from "styles/layout";

export const TeamsContainer = styled(CenterFlexRow)`
  justify-content: space-evenly;
`;

export const TeamContainer = styled.div`
  flex-basis: 0px;
`;

export const ByeTBD = styled.span`
  font-size: 20pt;
  color: gray;
`;

export const OrgLogoContainer = styled.div`
  width: 160px;
  height: 125px;
  padding-top: 10px;

  @media (max-width: 800px) {
    width: 120px;
    height: 80px;
    padding-bottom: 5px;
  }

  @media (max-width: 600px) {
    width: 75px;
    height: 75px;
  }

  @media (max-width: 500px) {
    width: 55px;
    height: 55px;
  }
`;

export const DisplayName = styled.span`
  font-size: 15pt;
  font-weight: 500;

  @media (max-width: 700px) {
    font-size: 13pt;
  }

  @media (max-width: 500px) {
    font-size: 10.5pt;
  }
`;

export const TeamRecord = styled.div`
  font-size: 11pt;
  color: gray;

  @media (max-width: 700px) {
    font-size: 10pt;
  }
`;

export const DriverNames = styled.span`
  font-size: 12pt;
  padding: 0 0 10px 0;

  @media (max-width: 800px) {
    font-size: 11pt;
  }

  @media (max-width: 500px) {
    font-size: 9.5pt;
  }
`;

export const Score = styled.span`
  white-space: nowrap;
  font-weight: bold;
  font-size: 38pt;

  @media (max-width: 800px) {
    font-size: 30pt;
  }

  @media (max-width: 600px) {
    font-size: 28pt;
  }

  @media (max-width: 500px) {
    font-size: 22pt;
  }
`;

export const BestOf = styled.span`
  font-size: 13pt;
  font-weight: normal;

  @media (max-width: 700px) {
    font-size: 12pt;
  }

  @media (max-width: 600px) {
    font-size: 11pt;
  }

  @media (max-width: 500px) {
    font-size: 9pt;
  }
`;
